/** Blank-line-separated paragraphs for a detail view's `About` — mirrors MJAPI's grantText.SplitParagraphs. */
export function SplitParagraphs(text: string): string[] {
    return text.split(/\r?\n\s*\r?\n/).map((p) => p.trim()).filter((p) => p.length > 0);
}
